import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../layout/Footer";
import Navbar from "../../layout/Navbar";

const PrivacyPolicy = () => {
    return (
        <>
        <Navbar />
        <div className="privacy-policy-page">
            <div className="container py-5 mt-5">
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-xl-8">
                        
                        {/* Header */}
                        <div className="text-center mb-5">
                            <h1 className="display-5 fw-bold mb-3">Privacy Policy</h1>
                            <p className="lead text-muted">
                                Last updated: {new Date().toLocaleDateString('en-US', { 
                                    year: 'numeric', 
                                    month: 'long', 
                                    day: 'numeric' 
                                })}
                            </p>
                            <div className="d-flex justify-content-center gap-3 mt-4">
                                <Link to="/" className="btn btn-outline-primary">
                                    <i className="bi bi-arrow-left me-2"></i>Back to Home
                                </Link>
                                <Link to="/contact" className="btn btn-primary">
                                    <i className="bi bi-envelope me-2"></i>Contact Us
                                </Link>
                            </div>
                        </div>

                        {/* Introduction */}
                        <div className="card shadow-sm border-0 mb-4">
                            <div className="card-body p-4">
                                <h2 className="h4 fw-bold mb-3">Introduction</h2>
                                <p>
                                    Welcome to <strong>PQ Hub</strong> ("we," "our," or "us"). We are committed to protecting 
                                    your personal information and your right to privacy. This Privacy Policy explains how we 
                                    collect, use, disclose, and safeguard your information when you use our mobile application 
                                    and website (collectively, the "Service").
                                </p>
                                <p>
                                    By accessing or using our Service, you agree to the terms of this Privacy Policy. 
                                    If you disagree with any part of this Privacy Policy, please do not use our Service.
                                </p>
                            </div>
                        </div>

                        {/* Information We Collect */}
                        <div className="card shadow-sm border-0 mb-4">
                            <div className="card-body p-4">
                                <h2 className="h4 fw-bold mb-3">Information We Collect</h2>
                                
                                <h3 className="h5 fw-semibold mt-4 mb-3">Personal Information</h3>
                                <p>We may collect personal information that you voluntarily provide when you:</p>
                                <ul className="list-group list-group-flush bg-transparent">
                                    <li className="list-group-item bg-transparent border-0 ps-0">
                                        <i className="bi bi-check-circle-fill text-primary me-2"></i>
                                        Register for an account
                                    </li>
                                    <li className="list-group-item bg-transparent border-0 ps-0">
                                        <i className="bi bi-check-circle-fill text-primary me-2"></i>
                                        Contact us via email or contact forms
                                    </li>
                                    <li className="list-group-item bg-transparent border-0 ps-0">
                                        <i className="bi bi-check-circle-fill text-primary me-2"></i>
                                        Subscribe to our newsletter
                                    </li>
                                    <li className="list-group-item bg-transparent border-0 ps-0">
                                        <i className="bi bi-check-circle-fill text-primary me-2"></i>
                                        Participate in surveys or feedback
                                    </li>
                                </ul>
                                <p className="mt-3">This may include:</p>
                                <div className="row mt-2">
                                    <div className="col-md-6">
                                        <div className="d-flex align-items-start mb-2">
                                            <div className="bg-light rounded p-2 me-3">
                                                <i className="bi bi-person text-primary"></i>
                                            </div>
                                            <div>
                                                <strong>Name</strong>
                                                <p className="small text-muted mb-0">Your full name</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="d-flex align-items-start mb-2">
                                            <div className="bg-light rounded p-2 me-3">
                                                <i className="bi bi-envelope text-primary"></i>
                                            </div>
                                            <div>
                                                <strong>Email Address</strong>
                                                <p className="small text-muted mb-0">Your contact email</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <h3 className="h5 fw-semibold mt-4 mb-3">Automatically Collected Information</h3>
                                <p>When you use our Service, we automatically collect:</p>
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <div className="card h-100 border">
                                            <div className="card-body">
                                                <h6 className="card-title">
                                                    <i className="bi bi-device-phone me-2"></i>
                                                    Device Information
                                                </h6>
                                                <p className="card-text small">Device type, operating system, browser type</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <div className="card h-100 border">
                                            <div className="card-body">
                                                <h6 className="card-title">
                                                    <i className="bi bi-globe me-2"></i>
                                                    Usage Data
                                                </h6>
                                                <p className="card-text small">Pages visited, time spent, features used</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <div className="card h-100 border">
                                            <div className="card-body">
                                                <h6 className="card-title">
                                                    <i className="bi bi-geo-alt me-2"></i>
                                                    Location Data
                                                </h6>
                                                <p className="card-text small">General location (country/region) for analytics</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <div className="card h-100 border">
                                            <div className="card-body">
                                                <h6 className="card-title">
                                                    <i className="bi bi-shield-check me-2"></i>
                                                    Cookies & Similar Tech
                                                </h6>
                                                <p className="card-text small">Session data, preferences, security tokens</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* How We Use Your Information */}
                        <div className="card shadow-sm border-0 mb-4">
                            <div className="card-body p-4">
                                <h2 className="h4 fw-bold mb-3">How We Use Your Information</h2>
                                <p>We use the information we collect to:</p>
                                
                                <div className="table-responsive mt-3">
                                    <table className="table table-hover">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Purpose</th>
                                                <th>Description</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td><strong>Service Operation</strong></td>
                                                <td>To provide, maintain, and improve our Service</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Communication</strong></td>
                                                <td>To respond to your inquiries and provide support</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Personalization</strong></td>
                                                <td>To customize your learning experience</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Analytics</strong></td>
                                                <td>To understand how users interact with our Service</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Security</strong></td>
                                                <td>To protect against fraud and unauthorized access</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Legal Compliance</strong></td>
                                                <td>To comply with applicable laws and regulations</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        {/* Data Sharing & Disclosure */}
                        <div className="card shadow-sm border-0 mb-4">
                            <div className="card-body p-4">
                                <h2 className="h4 fw-bold mb-3">Data Sharing & Disclosure</h2>
                                <p>We do not sell, trade, or rent your personal information to third parties. We may share information in the following circumstances:</p>
                                
                                <div className="alert alert-info">
                                    <h5 className="alert-heading">
                                        <i className="bi bi-info-circle me-2"></i>
                                        When We Share Your Data
                                    </h5>
                                    <ul className="mb-0">
                                        <li>With service providers who assist in operating our Service</li>
                                        <li>To comply with legal obligations or protect rights</li>
                                        <li>During business transfers (merger, acquisition)</li>
                                        <li>With your explicit consent</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        {/* Data Security */}
                        <div className="card shadow-sm border-0 mb-4">
                            <div className="card-body p-4">
                                <h2 className="h4 fw-bold mb-3">Data Security</h2>
                                <div className="row align-items-center">
                                    <div className="col-md-8">
                                        <p>
                                            We implement appropriate technical and organizational security measures to protect 
                                            your personal information. However, no method of transmission over the Internet or 
                                            electronic storage is 100% secure, and we cannot guarantee absolute security.
                                        </p>
                                        <div className="mt-3">
                                            <h5 className="fw-semibold">Our Security Measures Include:</h5>
                                            <div className="d-flex flex-wrap gap-2 mt-2">
                                                <span className="badge bg-primary">Encryption</span>
                                                <span className="badge bg-primary">Access Controls</span>
                                                <span className="badge bg-primary">Regular Audits</span>
                                                <span className="badge bg-primary">Secure Servers</span>
                                                <span className="badge bg-primary">Firewalls</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4 text-center">
                                        <div className="bg-light rounded-circle p-4 d-inline-block">
                                            <i className="bi bi-shield-lock display-4 text-primary"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Your Rights */}
                        <div className="card shadow-sm border-0 mb-4">
                            <div className="card-body p-4">
                                <h2 className="h4 fw-bold mb-3">Your Privacy Rights</h2>
                                <p>Depending on your location, you may have the following rights regarding your personal information:</p>
                                
                                <div className="row g-3 mt-3">
                                    {[
                                        { icon: 'eye', title: 'Right to Access', desc: 'Request copies of your data' },
                                        { icon: 'pencil', title: 'Right to Rectify', desc: 'Correct inaccurate information' },
                                        { icon: 'trash', title: 'Right to Delete', desc: 'Request deletion of your data' },
                                        { icon: 'pause', title: 'Right to Restrict', desc: 'Limit processing of your data' },
                                        { icon: 'download', title: 'Data Portability', desc: 'Receive your data in usable format' },
                                        { icon: 'x-circle', title: 'Right to Object', desc: 'Object to certain processing' }
                                    ].map((right, index) => (
                                        <div key={index} className="col-md-6 col-lg-4">
                                            <div className="card h-100 border">
                                                <div className="card-body text-center">
                                                    <div className="mb-3">
                                                        <i className={`bi bi-${right.icon} text-primary fs-3`}></i>
                                                    </div>
                                                    <h6 className="card-title fw-semibold">{right.title}</h6>
                                                    <p className="card-text small text-muted">{right.desc}</p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                
                                <div className="alert alert-light mt-4">
                                    <p className="mb-0">
                                        To exercise any of these rights, please contact us at{' '}
                                        <a href="mailto:eddcodes17@gmail.com" className="fw-semibold">eddcodes17@gmail.com</a>.
                                        We will respond to your request within 30 days.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Children's Privacy */}
                        <div className="card shadow-sm border-0 mb-4">
                            <div className="card-body p-4">
                                <h2 className="h4 fw-bold mb-3">Children's Privacy</h2>
                                <div className="d-flex align-items-start">
                                    <div className="bg-warning bg-opacity-10 rounded p-3 me-4">
                                        <i className="bi bi-exclamation-triangle text-warning fs-2"></i>
                                    </div>
                                    <div>
                                        <p>
                                            Our Service is not intended for children under 13 years of age. 
                                            We do not knowingly collect personal information from children under 13. 
                                            If you are a parent or guardian and believe your child has provided us 
                                            with personal information, please contact us immediately.
                                        </p>
                                        <p className="mb-0">
                                            If we learn we have collected personal information from a child under 13, 
                                            we will delete that information as quickly as possible.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Cookies */}
                        <div className="card shadow-sm border-0 mb-4">
                            <div className="card-body p-4">
                                <h2 className="h4 fw-bold mb-3">Cookies & Tracking Technologies</h2>
                                <p>
                                    We use cookies and similar tracking technologies to track activity on our Service 
                                    and hold certain information. Cookies are files with a small amount of data that 
                                    may include an anonymous unique identifier.
                                </p>
                                
                                <div className="mt-4">
                                    <h5 className="fw-semibold mb-3">Types of Cookies We Use:</h5>
                                    <div className="row">
                                        <div className="col-md-4 mb-3">
                                            <div className="card h-100">
                                                <div className="card-header bg-primary text-white">
                                                    <strong>Essential Cookies</strong>
                                                </div>
                                                <div className="card-body">
                                                    <p className="small">Required for basic site functionality</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <div className="card h-100">
                                                <div className="card-header bg-info text-white">
                                                    <strong>Performance Cookies</strong>
                                                </div>
                                                <div className="card-body">
                                                    <p className="small">Help us understand user behavior</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <div className="card h-100">
                                                <div className="card-header bg-success text-white">
                                                    <strong>Functionality Cookies</strong>
                                                </div>
                                                <div className="card-body">
                                                    <p className="small">Remember your preferences</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <p className="mt-3">
                                    You can instruct your browser to refuse all cookies or to indicate when a cookie 
                                    is being sent. However, if you do not accept cookies, you may not be able to use 
                                    some portions of our Service.
                                </p>
                            </div>
                        </div>

                        {/* Changes to This Policy */}
                        <div className="card shadow-sm border-0 mb-4">
                            <div className="card-body p-4">
                                <h2 className="h4 fw-bold mb-3">Changes to This Privacy Policy</h2>
                                <p>
                                    We may update our Privacy Policy from time to time. We will notify you of any changes 
                                    by posting the new Privacy Policy on this page and updating the "Last updated" date.
                                </p>
                                <p>
                                    You are advised to review this Privacy Policy periodically for any changes. 
                                    Changes to this Privacy Policy are effective when they are posted on this page.
                                </p>
                                
                                <div className="alert alert-warning">
                                    <h5 className="alert-heading">
                                        <i className="bi bi-bell me-2"></i>
                                        Update Notifications
                                    </h5>
                                    <p className="mb-0">
                                        For significant changes, we may also notify you via email or through 
                                        a prominent notice on our Service.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Contact Information */}
                        <div className="card shadow-sm border-0">
                            <div className="card-body p-4">
                                <h2 className="h4 fw-bold mb-3">Contact Us</h2>
                                <p>If you have any questions about this Privacy Policy, please contact us:</p>
                                
                                <div className="row mt-4">
                                    <div className="col-md-6 mb-3">
                                        <div className="card h-100 border">
                                            <div className="card-body">
                                                <h5 className="card-title">
                                                    <i className="bi bi-envelope text-primary me-2"></i>
                                                    Email
                                                </h5>
                                                <a href="mailto:eddcodes17@gmail.com" className="card-text d-block">
                                                    eddcodes17@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <div className="card h-100 border">
                                            <div className="card-body">
                                                <h5 className="card-title">
                                                    <i className="bi bi-geo-alt text-primary me-2"></i>
                                                    Address
                                                </h5>
                                                <p className="card-text">
                                                    Pegcodes Technologies<br />
                                                    Accra, Ghana
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="text-center mt-4">
                                    <p className="text-muted">
                                        We typically respond to privacy-related inquiries within 2-3 business days.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Footer Navigation */}
                        <div className="text-center mt-5 pt-4 border-top">
                            <div className="d-flex flex-wrap justify-content-center gap-3">
                                <Link to="/" className="text-decoration-none">Home</Link>
                                <Link to="/about" className="text-decoration-none">About</Link>
                                <Link to="/questions" className="text-decoration-none">Questions</Link>
                                <Link to="/contact" className="text-decoration-none">Contact</Link>
                            </div>
                            <p className="mt-3 text-muted small">
                                © {new Date().getFullYear()} PQ Hub. All rights reserved.
                            </p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <Footer />
        </>
    );
};

export default PrivacyPolicy;